module.exports = __webpack_public_path__ + "safari.jpg?b374249a7073af1d6b4b1d147ba220a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/safari.jpg
// module id = 29
// module chunks = 0